"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RoomWebsocketEvent = void 0;
/**
 * Websocket事件
 *
 * @enum {number}
 */
var RoomWebsocketEvent;
(function (RoomWebsocketEvent) {
    // 打开
    RoomWebsocketEvent["open"] = "open";
    // 关闭
    RoomWebsocketEvent["close"] = "close";
    // 连接
    RoomWebsocketEvent["connect"] = "connect";
    // 连接失败
    RoomWebsocketEvent["connectFail"] = "connectfail";
    // 重连中
    RoomWebsocketEvent["reconnecting"] = "reconnecting";
    // 断开
    RoomWebsocketEvent["disconnect"] = "disconnect";
    // 连接超时
    RoomWebsocketEvent["connectTimeout"] = "connect_timeout";
    // 连接错误
    RoomWebsocketEvent["connectError"] = "connect_error";
})(RoomWebsocketEvent || (RoomWebsocketEvent = {}));
exports.RoomWebsocketEvent = RoomWebsocketEvent;
